var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth container"},[_vm._m(0),_c('div',{staticClass:"auth__content content"},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/assets/images/logo_icon.svg"),"alt":""}}),_vm._v(" nrgYcon ")])
}]

export { render, staticRenderFns }